import { useState, useEffect } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";

import { FlyerButton } from "./style/performances";
import { Dialog, Button } from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import useWindowSize from "../utils/useWindowSize";
import styled from "styled-components";

const DownloadButton = styled(Button)`
  && {
    background-color: #4d4d4d;
    color: #fff;
    width: 200px;
    height: 50px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0;
    left: calc(100% - 200px);
    &:hover {
      background-color: #222;
      transition: background-color 0.3s ease-out;
    }
  }
`;

export default ({
  urls,
  titles,
  lang,
}: {
  urls: string[];
  titles: string[];
  lang: string;
}) => {
  const windowSize = useWindowSize();

  const [open, setOpen] = useState(false);
  const [modalImgs, setModalImgs] = useState([""]);

  const [display, setDisplay] = useState<{ [key: string]: boolean }>({});
  const [onButton, setOnButton] = useState<{ [key: string]: boolean }>({});

  const openDialog = (imgs: string[]) => {
    setOpen(true);
    setModalImgs(imgs);
  };
  const handleClose = () => {
    setOpen(false);
    setModalImgs([""]);
  };

  const [init, setInit] = useState(false);

  useEffect(() => {
    if (!init) {
      const initialState: { [key: string]: boolean } = {};

      urls.forEach((_, i) => {
        initialState[i.toString()] = false;
      });

      setDisplay(initialState);
      setOnButton(initialState);

      setInit(true);
    }
  }, [urls]);

  const downloadImage = async (url: string, title: string) => {
    if (!url) return;

    const imageRaw = await axios.get(url, {
      responseType: "arraybuffer",
    });
    const data = Buffer.from(imageRaw.data, "binary");
    const base64 = data.toString("base64");

    const jspdf = new jsPDF();
    jspdf.addImage(
      base64,
      0,
      0,
      jspdf.internal.pageSize.getWidth(),
      jspdf.internal.pageSize.getHeight()
    );
    jspdf.save(title);
  };

  return init ? (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="flyer"
        maxWidth="lg"
      >
        {urls.length &&
          urls.map((url, i) => {
            const title = titles[i];
            const modalImg = modalImgs[i];
            return modalImg ? (
              <div key={i} style={{ position: "relative" }}>
                <img
                  src={modalImg}
                  alt="modal"
                  onContextMenu={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  style={{
                    objectFit: "contain",
                    width: "100%",
                  }}
                  onMouseEnter={() => {
                    if (windowSize !== "mobile") {
                      setDisplay((prev) => ({ ...prev, [i]: true }));
                    }
                  }}
                  onMouseLeave={() => {
                    if (windowSize !== "mobile") {
                      if (!onButton[i]) {
                        setDisplay((prev) => ({ ...prev, [i]: false }));
                      }
                    }
                  }}
                />
                {display[i] && (
                  <DownloadButton
                    onMouseEnter={() => {
                      if (windowSize !== "mobile") {
                        setDisplay((prev) => ({ ...prev, [i]: true }));
                        setOnButton((prev) => ({ ...prev, [i]: true }));
                      }
                    }}
                    onMouseLeave={() => {
                      if (windowSize !== "mobile") {
                        setDisplay((prev) => ({ ...prev, [i]: false }));
                        setOnButton((prev) => ({ ...prev, [i]: false }));
                      }
                    }}
                    onClick={() => downloadImage(url, title)}
                  >
                    <CloudDownloadIcon style={{ marginRight: "10px" }} />
                    {lang === "ja"
                      ? "ダウンロード"
                      : lang === "en"
                      ? "Download"
                      : ""}
                  </DownloadButton>
                )}
              </div>
            ) : (
              <></>
            );
          })}
      </Dialog>

      <FlyerButton
        onClick={() => {
          openDialog(urls.map((url) => `${url}?w=500`));
        }}
        aria-label="flyer image"
      >
        {lang === "ja" ? "フライヤー画像" : lang === "en" ? "Flyer image" : ""}
      </FlyerButton>
    </>
  ) : (
    <p></p>
  );
};
